import React, { useState, useRef } from 'react'
import '../styles/SixDigitCode.css'

export function SixDigitCodeInput({ onChange }) {
  const [code, setCode] = useState(['', '', '', '', '', ''])
  const inputRefs = useRef([])

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return // Allow only digits

    const newCode = [...code]
    newCode[index] = value
    setCode(newCode)

    // Move focus to next input if a digit is entered
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }

    // Notify parent of current code value
    onChange?.(newCode.join(''))
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  return (
    <div className="code-container">
      {code.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          dir="ltr"
          value={digit}
          maxLength={1}
          className="code-input"
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
        />
      ))}
    </div>
  )
}
